import { Input, InputAdornment, Typography } from '@mui/material';
import React from 'react';
import { MdFilterList, MdSearch } from 'react-icons/md';

import { RootStyled } from './FinanceSuperAdmin.styles';
import { UsersTable } from './UsersTable';

export function FinanceSuperAdmin() {
  return (
    <RootStyled>
      <Typography variant="h3">Finanças</Typography>
      <hr />
      <section>
        <Typography variant="h4">Faturamento mensal</Typography>
        <div>
          <Typography variant="h4" className="amount">
            R$ 45.000,00
          </Typography>
        </div>
        <div />
      </section>
      <hr />
      <section>
        <Typography variant="h4">Usuários</Typography>
        <div style={{ marginLeft: 162 }}>
          <div style={{ display: 'flex', gap: 8 }}>
            <Typography variant="h4">Ativos:</Typography>
            <Typography variant="h4" className="amount">
              60
            </Typography>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Typography variant="h4">Em atraso:</Typography>
            <Typography variant="h4" className="amount">
              8
            </Typography>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Typography variant="h4">Período de teste:</Typography>
            <Typography variant="h4" className="amount">
              60
            </Typography>
          </div>
        </div>
        <div />
      </section>
      <hr />
      <section>
        <Typography variant="h4">Usuários em atraso</Typography>
        <div
          style={{
            backgroundColor: '#212334',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: 450,
            padding: '0 16px',
            borderRadius: 2,
          }}
        >
          <Input
            placeholder=" Pesquisar administrador"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MdSearch color="lightgray" />
                </InputAdornment>
              ),
            }}
          />
          <MdFilterList color="lightgray" size={22} />
        </div>
      </section>
      <div style={{ margin: '24px 0' }} />
      <UsersTable />
    </RootStyled>
  );
}
